module.exports = __webpack_public_path__ + "img/bigwin-text.11ef83f6.png";